export default __webpack_public_path__ + "static/media/pagination-prev.91ca25a4.svg";